import { render, staticRenderFns } from "./AddProductOperator.vue?vue&type=template&id=2583844a&scoped=true&"
import script from "./AddProductOperator.vue?vue&type=script&lang=js&"
export * from "./AddProductOperator.vue?vue&type=script&lang=js&"
import style0 from "./AddProductOperator.vue?vue&type=style&index=0&id=2583844a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583844a",
  null
  
)

component.options.__file = "AddProductOperator.vue"
export default component.exports